import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover este agendamento para data <b>${this.currentEntity.go_in_out}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/moving/resources/computed.js